import React from "react";
import { HashLink as Link } from 'react-router-hash-link';

const NewsCard = (props) => {
    return (
        <div>
            <img src={process.env.PUBLIC_URL + "/assets/images/News/" + props.newsItem.imgLink} alt="" className="img-fluid mr-3" />
            <div className="card-body">
                 {props.newsItem.to !== undefined ? (
                      <Link className="nav-link initiate-scripts h4 text-dark" to={'/news/' + props.newsItem.id}>{props.newsItem.title}</Link>
                 ) : (
                    <a target="_blank" rel="noopener noreferrer" href={props.newsItem.href} className="h4 text-dark">{props.newsItem.title}</a>
                 )
                }
            </div>
        </div>

    );
}

export default NewsCard;